import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TeamViewComponent } from './team-view/team-view.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { TeamMemberViewComponent } from './team-member-view/team-member-view.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { TeamMemberIssueComponent } from './team-member-issue/team-member-issue.component';
import {MatIconModule} from '@angular/material/icon';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {TextFieldModule} from '@angular/cdk/text-field';
import {FormsModule } from '@angular/forms';
import { TeamConflictContainerComponent } from './team-conflict-container/team-conflict-container.component';
import { TeamConflictCoreSelectionComponent } from './team-conflict-core-selection/team-conflict-core-selection.component';
import { TeamConflictActionSelectionComponent } from './team-conflict-action-selection/team-conflict-action-selection.component';
import {MatDividerModule} from '@angular/material/divider';
import { MoovCommonModule } from '../moov-common/moov-common.module';
import { MakeMoovModule } from '../make-moov/make-moov.module';
import {MatStepperModule} from '@angular/material/stepper'; 
import { TeamActiveMoovsViewComponent } from './team-active-moovs-view/team-active-moovs-view/team-active-moovs-view.component';
import { TeamMemberViewInsightsComponent } from './team-member-view-insights/team-member-view-insights.component';
import { RelationshipComponent } from './relationship/relationship/relationship.component';
import { TeamViewSideNavContainerComponent } from './team-view-side-nav-container/team-view-side-nav-container/team-view-side-nav-container.component';
import { TeamMemberViewMoovsComponent } from './team-member-view-moovs/team-member-view-moovs.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TeamViewFiltersComponent } from './team-view-filters/team-view-filters.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
// import { MatCarouselModule } from '@ngbmodule/material-carousel';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  declarations: [
    TeamViewComponent,
    TeamMemberViewComponent,
    TeamMemberIssueComponent,
    TeamConflictContainerComponent,
    TeamConflictCoreSelectionComponent,
    TeamConflictActionSelectionComponent,
    TeamActiveMoovsViewComponent,
    TeamMemberViewInsightsComponent,
    RelationshipComponent,
    TeamViewSideNavContainerComponent,
    TeamMemberViewMoovsComponent,
    TeamViewFiltersComponent
  ],
  imports: [
    MoovCommonModule,
    CommonModule,
    MatGridListModule,
    MatDialogModule,
    MatSidenavModule,
    MatButtonModule,
    MatListModule,
    MatMenuModule,
    MatIconModule,
    MatTooltipModule,
    MatExpansionModule,
    MatButtonToggleModule,
    TextFieldModule,
    MatInputModule,
    FormsModule,
    MatTabsModule,
    MatDividerModule,
    MakeMoovModule,
    MatStepperModule,
    MatListModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    // MatCarouselModule.forRoot(),
  ],
  exports:[
    TeamViewComponent,
    TeamMemberViewInsightsComponent,
  ]
})
export class TeamViewModule { }
